import { reactive } from "vue";

export const storesidebar = reactive({
  isNavOpen: false
});

export const mutations = {
  setIsNavOpen(yesno) {
    storesidebar.isNavOpen = yesno;
  },
  toggleNav() {
    storesidebar.isNavOpen = !storesidebar.isNavOpen;
  }
};
